import { useMemo } from "react";

import type { IssueRow } from "#app/lib/data";
import { useEntityList } from "../entity-list/use-entity-list";
import { useIssueRowsPaged } from "../shared/use-issue-rows-paged";

/**
 * The data layer for the `added-list` card: the viewer's newest Projects,
 * newest first, capped at `limit`. The rows are the scoped, server-ordered
 * set the `entity-list` card pages (`useEntityList("created")`: the member
 * scope plus the dashboard window) — the first page is wider than any
 * `limit`, so its head is the list and no client sort is needed.
 */
export function useAddedList(limit: number): {
  items: IssueRow[];
  /** The project page is still in flight. */
  issuesLoading: boolean;
} {
  const { where, orderBy } = useEntityList("created", undefined, "");
  const query = useMemo(() => ({ where, orderBy }), [where, orderBy]);
  const { rows, loading: issuesLoading } = useIssueRowsPaged(query);

  const items = useMemo(() => rows.slice(0, limit), [limit, rows]);

  return { items, issuesLoading };
}
